import { Component, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { PreAuthenticationResponse, RegisterRequestModel, LogonTypeEnum, PrivateDataModel, LogonRequest, LogonResponse, PermissionType } from '@picard/models-lib';
import { StorageConstants } from '@picard/shared-lib';
import { AuthenticationService, PreAuthenticationService, ApplicationService } from '@picard/services-lib';
import Swal from 'sweetalert2';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Message } from 'primeng/primeng';
import { RegistrationService } from 'src/app/services/registration.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit {
  //#region Properties
  preAuthenticationResponse: PreAuthenticationResponse;
  mobileNumber: string;
  membershipNumber: string;
  showRetry: boolean;
  inRegistration: boolean;
  otp: any;
  partnerCode: string;
  msgs: Message[] = [];
  programId: number;
  optInFormGroup: FormGroup;
  optedIn: boolean = false;
  @BlockUI() blockUI: NgBlockUI;
  docTheme = document.getElementById('theme-css');
  docLayout = document.getElementById('layout-css');
  //#endregion Properties

  //#region Constructor
  constructor(private _authenticationService: AuthenticationService, private _router: Router, private _activatedRoute: ActivatedRoute, private _preAuthenticationService: PreAuthenticationService, private _applicationService: ApplicationService, private _registrationService: RegistrationService, private _formBuilder: FormBuilder) {
    this.inRegistration = false;
  }
  //#endregion Constructor

  //#region Functions
  async ngOnInit() {
    /*
      this.programId = this.preAuthenticationResponse.programId; // parseInt(sessionStorage.getItem('programId')); // this._applicationService.preAuthenticationResponse.programId;if (this.docTheme) {
      this.docTheme.setAttribute('href', this._applicationService.preAuthenticationResponse.programmeAssetsModel.theme);
    }
    if (this.docLayout) {
      this.docLayout.setAttribute('href', this._applicationService.preAuthenticationResponse.programmeAssetsModel.layout);
    } */

    this._activatedRoute.queryParams.subscribe((params: Params) => (this.partnerCode = params['partner']));
    this.msgs = [];
    this.msgs.push({ severity: 'info', detail: `Please enter the number you use on the keypad at Seattle Coffee Company, this is your Loyalty Number` });
    const hostInformation = location.hostname.split('.', 3);
    if (hostInformation[0].toLowerCase() !== 'localhost') {
      this.partnerCode = hostInformation[0];
    }
    let preAuthJson = sessionStorage.getItem(StorageConstants.preAuth);
    if (preAuthJson) {
      this.preAuthenticationResponse = JSON.parse(preAuthJson);

    if (this.docTheme) {
      this.docTheme.setAttribute('href', this.preAuthenticationResponse.programmeAssetsModel.theme);
    }
    if (this.docLayout) {
      this.docLayout.setAttribute('href', this.preAuthenticationResponse.programmeAssetsModel.layout);
    }

      this.programId = this.preAuthenticationResponse.programId;
      if (this.programId === 2555) this.optedIn = true;
      this.setBody();
    } else {
      const preAuthResponse = await this._preAuthenticationService.PreAuthenticationAsync(this.partnerCode);
      sessionStorage.setItem(StorageConstants.preAuth, JSON.stringify(preAuthResponse));
      preAuthJson = sessionStorage.getItem(StorageConstants.preAuth);

      if (preAuthResponse.programId === 2222) {
        const preAuthResponseBeans = await this._preAuthenticationService.PreAuthenticationAsync('scbn');
        sessionStorage.setItem('preAuthBeans', JSON.stringify(preAuthResponseBeans));
      }

      this.preAuthenticationResponse = JSON.parse(preAuthJson);

      if (this.docTheme) {
        this.docTheme.setAttribute('href', this.preAuthenticationResponse.programmeAssetsModel.theme);
      }
      if (this.docLayout) {
        this.docLayout.setAttribute('href', this.preAuthenticationResponse.programmeAssetsModel.layout);
      }

        this.programId = this.preAuthenticationResponse.programId;
      this.setBody();
    }

    // -----------------
    this.optInFormGroup = this._formBuilder.group({
      firstname: ['', Validators.required],
      surname: ['', Validators.required],
      email: ['', Validators.required, Validators.email],
      mobileNumber: ['', Validators.required]
    });
  }
  /*get email() {
    return this.optInFormGroup.get('email');
  }*/
  setBody() {
    const htmlBody: HTMLLinkElement = <HTMLLinkElement>document.getElementById('picard-body');
    if (htmlBody !== null) {
      htmlBody.className = 'login-body';
      htmlBody.style.backgroundImage = `url("${this.preAuthenticationResponse.programmeAssetsModel.imageAssetsModel.bodyUrl}")`;
    }
  }
  async startRegistration() {
    const registerRequestModel = new RegisterRequestModel();
    registerRequestModel.programmeId = this.preAuthenticationResponse.programId;
    registerRequestModel.logonType = LogonTypeEnum.Mobile_Number;
    registerRequestModel.logonTypeValue = this.mobileNumber;
    registerRequestModel.membershipNumber = this.membershipNumber;
    registerRequestModel.permissionType = PermissionType.user;
    this.blockUI.start('Trying to register.');
    const response = await this._authenticationService.registerAsync(registerRequestModel);
    this.blockUI.stop();
    if (!response.isSuccessful) {
      Swal('Number entered: ' + this.mobileNumber, response.customMessage, 'error');
      // Swal('Number entered: ' + this._registrationService.registerRequestModel.logonTypeValue, response.customMessage, 'error');
      this.inRegistration = false;
    } else {
      Swal('Number entered: ' + this.mobileNumber, response.customMessage, 'success');
      this.inRegistration = true;
    }
  }
async startOptInRegistration(){
  const registerRequestModel = new RegisterRequestModel();
  registerRequestModel.programmeId = this.preAuthenticationResponse.programId;
  registerRequestModel.logonType = LogonTypeEnum.Mobile_Number;
  registerRequestModel.logonTypeValue = this.optInFormGroup.get('mobileNumber').value;
  this.mobileNumber = this.optInFormGroup.get('mobileNumber').value;
  registerRequestModel.membershipNumber = this.membershipNumber;
  registerRequestModel.permissionType = PermissionType.user;
  registerRequestModel.firstname = this.optInFormGroup.get('firstname').value;
  registerRequestModel.surname = this.optInFormGroup.get('surname').value;
  registerRequestModel.secondaryCommsField = this.optInFormGroup.get('email').value;
  registerRequestModel.subscribed = this.optedIn;
  console.log('registerRequestModel below:');
  console.log(registerRequestModel);

  this.blockUI.start('Trying to register.');
    const response = await this._authenticationService.registerAsync(registerRequestModel);
    this.blockUI.stop();
    if (!response.isSuccessful) {
      Swal('Number entered: ' + this.optInFormGroup.get('mobileNumber').value, response.customMessage, 'error');
      // Swal('Number entered: ' + this._registrationService.registerRequestModel.logonTypeValue, response.customMessage, 'error');
      this.inRegistration = false;
    } else {
      Swal('Number entered: ' + this.optInFormGroup.get('mobileNumber').value, response.customMessage, 'success');
      this.inRegistration = true;
    }
}

  async addValue(num) {
    if (!this.otp) {
      this.otp = '';
    }
    if (this.otp.length < 5) {
      this.otp += num;
    }
    if (this.otp.length === 5) {
      const privateDataModel = new PrivateDataModel();
      privateDataModel.logonType = this.preAuthenticationResponse.loginType;
      privateDataModel.password = this.otp;
      privateDataModel.typeValue = this.mobileNumber;

      const logonRequest = new LogonRequest();
      logonRequest.programmeShortCode = this.preAuthenticationResponse.code;
      logonRequest.privateData = btoa(JSON.stringify(privateDataModel));
      this.blockUI.start('Logging you in.');
      const authenticationAsyncResponse = await this._authenticationService.AuthenticationAsync(logonRequest);
      this.blockUI.stop();
      this.logonSuccessMessage(authenticationAsyncResponse);
    }
  }
  async onLogin() {
    const privateDataModel = new PrivateDataModel();
      privateDataModel.logonType = this.preAuthenticationResponse.loginType;
      privateDataModel.password = this.otp;
      privateDataModel.typeValue = this.mobileNumber;

      const logonRequest = new LogonRequest();
      logonRequest.programmeShortCode = this.preAuthenticationResponse.code;
      logonRequest.privateData = btoa(JSON.stringify(privateDataModel));
      this.blockUI.start('Logging you in.');
      const authenticationAsyncResponse = await this._authenticationService.AuthenticationAsync(logonRequest);
      this.blockUI.stop();
      this.logonSuccessMessage(authenticationAsyncResponse);
  }
  logonSuccessMessage(response: LogonResponse) {
    if (response.isLoggedOn) {
      sessionStorage.setItem(StorageConstants.loginDetails, JSON.stringify(response));
      Swal({ type: 'success', title: 'Logon successful', showConfirmButton: false, timer: 1500 });
      this._router.navigateByUrl('/dashboard');
    } else {
      Swal({ type: 'error', title: 'Logon failed:' + response.customLogonMessage, showConfirmButton: false, timer: 2000 });
    }
  }
  saveMobile() {
    this._registrationService.registerRequestModel.programmeId = this.preAuthenticationResponse.programId;
    this._registrationService.registerRequestModel.logonType = LogonTypeEnum.Mobile_Number;
    this._registrationService.registerRequestModel.logonTypeValue = this.mobileNumber;
    this._registrationService.registerRequestModel.permissionType = PermissionType.user;
    this._router.navigateByUrl('/visited-us-before');
  }
  login() {
    this._router.navigateByUrl(`/login`);
  }
  //#endregion Functions
}
